import React from "react";
import { resolveBlockRows } from "../utils/apartmentFields";

const ApartmentDetails = ({ apartment, apartmentBlockFieldsOrder }) => {
  if (!apartment || !apartment.display_fields) {
    return null; // Return null if apartment or display_fields is not available
  }
  const rows = resolveBlockRows(apartment, apartmentBlockFieldsOrder);
  return (
    <div className="apartment-details d-flex">
      {rows.map((row) => (
        <div key={row.key} className="detailsList pill">
          {/* Use a div instead of li to avoid list styling */}
          <div className="d-flex mb-1">
            <span>
              {row.title} {row.value}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ApartmentDetails;
